import { EntityType, IssuerOrganisation, IssuerOrganisationDetail } from 'api'
import { createSelector, Selector } from '@reduxjs/toolkit'
import { GlobalState } from 'store'
import { createAllEntitiesSelector, createAllEntitiesSortedSelector } from './entitySelectors'

export const createIssuerOrganisationByIdGetterSelector: Selector<
  GlobalState,
  (organisationId: number | null) => IssuerOrganisation | null
> = createSelector([createAllEntitiesSelector(EntityType.ISSUER_ORGANISATION)], issuerOrganisations => (organisationId: number | null) =>
  organisationId ? issuerOrganisations.find(issuerOrganisation => issuerOrganisation.issuerOrganisationId === organisationId) ?? null : null
)

export const issuerOrganisationsDetailsSelector: Selector<GlobalState, IssuerOrganisationDetail[]> = createSelector(
  [createAllEntitiesSortedSelector(EntityType.ISSUER_ORGANISATION), createIssuerOrganisationByIdGetterSelector],
  (issuerOrganisations, getIssuerOrganisationById) => {
    return issuerOrganisations.map(issuerOrganisation => {
      const parentOrganisation = getIssuerOrganisationById(issuerOrganisation.ultimateParentIssuerOrganisationId)
      const ultimateParentName = parentOrganisation && parentOrganisation.issuerName
      const ultimateParentLEI = parentOrganisation && parentOrganisation.issuerLei
      const ultimateParentPermId = parentOrganisation && parentOrganisation.ultimateParentPermId
      return { issuerOrganisation, ultimateParentName, ultimateParentLEI, ultimateParentPermId }
    })
  }
)
